import NiceModal, { useModal } from '@ebay/nice-modal-react';
import { useTranslation } from 'next-i18next';
import { Modal } from '@components/common/Modal/Modal';
import { BuyMyBestieHub } from './BuyMyBestieHub';

interface BuyMyBestieModalProps {
  successCallback?: () => void;
}

/**
 * @description NiceModal wrapper for the My Bestie purchase flow.
 * Can be opened anywhere via `showBuyMyBestieModal()`.
 */
export const BuyMyBestieModal = NiceModal.create((props: BuyMyBestieModalProps) => {
  const { successCallback } = props;
  const modal = useModal();
  const { t } = useTranslation('common');

  const closeModal = () => {
    void modal.hide();
  };

  return (
    <Modal
      isOpen={modal.visible}
      onClose={closeModal}
      backdropClickDisabled
      size="md"
      containerClasses="lg:left-[var(--two-column-header-offset,0px)] lg:w-auto"
      header={t('mc.personal.agent')}
      body={(
        <BuyMyBestieHub
          successCallback={successCallback}
        />
      )}
    />
  );
});

/**
 * @description Opens the My Bestie purchase modal anywhere in the app.
 *
 * @example
 * import { showBuyMyBestieModal } from '@components/features/modals/buy-my-bestie/BuyMyBestieModal';
 * <Button onClick={() => showBuyMyBestieModal()}>Activate My Bestie</Button>
 */
export const showBuyMyBestieModal = (successCallback?: () => void) => {
  void NiceModal.show(BuyMyBestieModal, { successCallback });
};
